/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportHistoryPagedList } from '../../models/auth-support-history-paged-list';
import { AuthSupportHistorySortFieldName } from '../../models/auth-support-history-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface GetAuthSupportChangesHistory$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  sortFieldName?: AuthSupportHistorySortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;
}

export function getAuthSupportChangesHistory(http: HttpClient, rootUrl: string, params: GetAuthSupportChangesHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportHistoryPagedList>> {
  const rb = new RequestBuilder(rootUrl, getAuthSupportChangesHistory.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportHistoryPagedList>;
    })
  );
}

getAuthSupportChangesHistory.PATH = '/auth-supports/{uid}/history';
